import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  select: {
    width: "90%",
    margin: "0 auto",
    display: "flex",
    height: "100%",
    justifyContent: "center",
  },
  selectButton: {
    margin: "1.5vw",
    padding: "4vw",
    backgroundColor: "black",
    borderRadius: "0.6vw",
    color: "white",
    fontSize: "2.5vw",
    fontWeight: "bold",
    cursor: "pointer",
    border: "0.2vw solid black",
    width: "100%",
    outline: "none",
    "&:hover": {
      backgroundColor: "white",
      color: "black",
    },
  },
  expectedValue: {
    display: "block",
  },
  create: {
    backgroundColor: "black",
    borderRadius: "0.5vw",
    color: "white",
    fontWeight: "bold",
    padding: "0.4vw 1vw",
    cursor: "pointer",
    outline: "none",
    border: "0.2vw black solid",
    "&:hover": {
      backgroundColor: "white",
      color: "black",
    },
    marginBottom: "1vw",
  },
  valueInput: {
    width: "100%",
    padding: "0.7vw",
    boxSizing: "border-box",
    lineHeight: "1",
    margin: "0 auto",
  },
  swap: {
    color: "white",
    border: "0.2vw black solid",
    cursor: "pointer",
    margin: "0 1.4vw 1.4vw 1.4vw",
    outline: "none",
    padding: "0.7vw",
    lineHeight: "1vw",
    borderRadius: "1vw",
    backgroundColor: "black",
    fontSize: "1.5vw",
    "&:hover": {
      backgroundColor: "white",
      color: "black",
    },
  },
  msg: {
    margin: "1.4vw 1vw",
    fontSize: "2.1vw",
  },
  swapScreen: {
    display: "flex",
    justifyContent: "center",
    height: "100%",
  },
  swaps: {
    flexGrow: 1,
    overflowY: "auto",
  },
  or: {
    display: "flex",
    flexGrow: "1",
    alignItems: "center",
    justifyContent: "center",
    fontWeight: "bold",
    fontSize: "2.5vw",
    background: "linear-gradient(#000, #000) no-repeat center/2px 100%",
    "& p": {
      background: "white",
    },
  },
  newSwap: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    flexGrow: 1,
  },
  createWrap: {
    width: "28vw",
    padding: "2vw 2vw 0.7vw 2vw",
    border: "0.3vw solid black",
    borderRadius: "1vw",
  },
  container: {
    width: "45%",
    maxHeight: "100%",
    display: "flex",
    flexDirection: "column",
  },
  swapValue: { position: "relative", width: "19vw", margin: "1vw auto" },
  maxButton: {
    border: "0.2vw black solid",
    cursor: "pointer",
    right: "0",
    bottom: "0",
    zIndex: "2",
    position: "absolute",
    padding: "0.54vw 0.4vw",
    background: "black",
    color: "white",
    "&:hover": {
      backgroundColor: "white",
      color: "black",
    },
  },
  select: {
    textAlign: "center",
    "& ul": {
      backgroundColor: "black",
      textAlign: "center",
    },
    "& li": {
      fontSize: "1vw",
      fontWeight: "bold",
      backgroundColor: "black",
      color: "white",
      textAlign: "center",
    },
  },
  dropdown: {
    color: "white",
    background: "black",
    padding: "0.7vw 1vw",
    borderRadius: "0.3vw",
    fontWeight: "bold",
    width: "fit-content",
    textAlign: "center",
    "&:focus": {
      background: "black",
      borderRadius: "0.3vw",
      width: "7vw",
      textAlign: "center",
    },
  },
  balances: {
    border: "0.3vw solid black",
    margin: "1vw",
    padding: "1vw",
    borderRadius: "1vw",
    fontWeight: "bold",
  },
  dropdownIcon: {
    color: "white",
    padding: "0 0.2vw",
  },
}));

export default useStyles;
